module.exports = __webpack_public_path__ + "static/tokr-webData-2c827b6ae91389a81ab7f3dcd12a8930.jpg";